module.exports = __webpack_public_path__ + "static/assets/0af9b1fc4a2f626d83cbb37f100b9745.svg";